import React from "react";

const TeamCard = ({ image, name, description, position }) => {
  return (
    <div className="text-left fade-in">
      <img
        className="w-full h-[400px] lg:h-[85vh] object-cover rounded-xl overflow-hidden bg-white"
        src={image}
        alt={name}
      />
      <div>
        <div className="text-black font-medium text-base mt-3 bg-[#f3f4f6] inline-block px-2">
          <p>{position}</p>
        </div>
        <div className="font-semibold text-[16px] md:text-[24px] mt-1 text-black mb-2">{name}</div>
        {description}
      </div>
    </div>
  );
};

export default TeamCard;
